module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_dimopoulos_2.87f21cb2.jpg";